const icon = require('./icons/unknown-100.png')

export const UnknownIcon = () => {
  return <img src={icon} alt="unknown status icon" className="w-full h-full"/>
}
